<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.workSchedule.workSchedule') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.employee.workSchedule.workSchedule'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-loading-banner :loading="ready_fetch">
        <ts-card-wrapper>
          <form class="form-horizontal">
            <div class="ts-flex">
              <div class="ts-flex">
                <label class="col-sm-4 control-label">
                  {{ $t('administration.employee.workSchedule.year') }}</label
                >
                <div>
                  <ts-date-picker-input
                    :class="{ 'is-invalid': errors.has('cycle_year') }"
                    format="YYYY"
                    v-model="model.cycle_year"
                    @input="getWorkSchedule"
                  ></ts-date-picker-input>
                </div>
                <div class="invalid-feedback" v-if="errors.has('cycle_year')">
                  {{ errors.first('cycle_year') }}
                </div>
              </div>
              <div class="ts-flex">
                <label class="col-sm-4 control-label">
                  {{ $t('administration.employee.workSchedule.month') }}</label
                >
                <div>
                  <ts-date-picker-input
                    :class="{ 'is-invalid': errors.has('cycle_month') }"
                    format="MM"
                    v-model="model.cycle_month"
                    @input="getWorkSchedule"
                  ></ts-date-picker-input>
                </div>
                <div class="invalid-feedback" v-if="errors.has('cycle_month')">
                  {{ errors.first('cycle_month') }}
                </div>
              </div>
              <div class="ts-flex">
                <label class="col-sm-6 control-label">
                  {{ $t('administration.employee.workSchedule.shift') }}
                </label>
                <div>
                  <select
                    style="width: 150%"
                    :class="{ 'is-invalid': errors.has('shift_id') }"
                    v-model="model.shift_id"
                    class="form-control"
                    @change="getWorkSchedule"
                  >
                    <option value="" disabled selected style="display: none">
                      {{ $t('select') }}
                    </option>
                    <option
                      v-for="(shift, index) in shifts"
                      :key="index"
                      :value="shift.shift_id"
                    >
                      {{ shift.shift_name }} ({{ shift.shift_type }})
                    </option>
                  </select>
                </div>
                <div class="invalid-feedback" v-if="errors.has('shift_id')">
                  {{ errors.first('shift_id') }}
                </div>
              </div>
              <div class="ts-flex-grow"></div>
              <ts-button
                color="success"
                outline
                class="mr-2"
                :disabled="model.details.length <= 0 || saving"
                @click.prevent="save"
                :waiting="saving"
              >
                {{ $t('export') }}
              </ts-button>
              <ts-button
                color="success"
                outline
                class="mr-2"
                @click.prevent="() => (showForm = true)"
              >
                {{ $t('copy') }}</ts-button
              >
              <ts-button
                class="btn-primary"
                :disabled="model.details.length <= 0 || saving"
                @click.prevent="save"
                :waiting="saving"
              >
                {{ $t('save') }}
              </ts-button>
            </div>
          </form>
          <ts-loading-banner :loading="table_loading">
            <div class="menu-container">
              <div class="schedule-table-container">
                <table
                  class="table table-bordered"
                  v-if="model.details.length > 0 && !table_loading"
                >
                  <thead>
                    <tr>
                      <th hidden>Staff ID</th>
                      <th>
                        {{
                          $t('administration.employee.workSchedule.employeeId')
                        }}
                      </th>
                      <th>
                        {{
                          $t(
                            'administration.employee.workSchedule.employeeName'
                          )
                        }}
                      </th>
                      <th
                        style="vertical-align: middle"
                        v-for="(column, index) in header"
                        :key="index"
                      >
                        {{ column }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in model.details" :key="index">
                      <td hidden>{{ data.staff_id }}</td>
                      <td>{{ data.emp_id }}</td>
                      <td>{{ data.staff_name }}</td>
                      <td
                        v-for="(column, columnIndex) in header"
                        :key="columnIndex"
                      >
                        <select
                          class="form-control border-none"
                          v-model="data[column]"
                        >
                          <option v-if="data[column] === null" :value="null">
                            -
                          </option>
                          <option v-else value="">-</option>
                          <option
                            v-for="(special_keyword, index) in special_keywords"
                            :key="index"
                            :value="special_keyword.keyowrd"
                          >
                            {{ special_keyword.keyowrd }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ts-loading-banner>
        </ts-card-wrapper>
      </ts-loading-banner>
    </ts-card>
    <br />
    <ul class="list-group list-group-flush col-md-3">
      <li
        v-for="(special_keyword, index) in special_keywords"
        :key="index"
        class="list-group-item"
      >
        <span>{{ special_keyword.keyowrd }}</span>
        <p class="pull-right text-primary">
          {{ special_keyword.description }}
        </p>
      </li>
    </ul>
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('administration.employee.workSchedule.workSchedule')"
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="700px"
    >
      <copy-form @close="() => (showForm = false)" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import CopyForm from './copy-form'

export default {
  name: 'work-schedule-form',
  components: {
    CopyForm
  },
  data () {
    return {
      model: {
        cycle_year: moment().format('YYYY'),
        cycle_month: moment().format('MM'),
        shift_id: '',
        details: []
      },
      saving: false,
      showForm: false,
      header: [],
      table_loading: false,
      ready_fetch: false,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('workSchedule', ['shifts', 'special_keywords'])
  },
  created () {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    subString (string) {
      if (string === '' || string === undefined || string === null) return
      return string.substr(2)
    },

    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('workSchedule/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    async getWorkSchedule () {
      if (
        this.model.cycle_year == '' ||
        this.model.cycle_month == '' ||
        this.model.shift_id == ''
      )
        return
      this.table_loading = true
      await this.$store.dispatch(
        'workSchedule/getSpecialKeyword',
        this.model.shift_id
      )
      try {
        let response = await this.$store.dispatch('workSchedule/fetch', {
          cycle_year: this.model.cycle_year,
          cycle_month: this.model.cycle_month,
          shift_id: this.model.shift_id
        })
        this.model.details = response.data
        this.header = response.header
        this.table_loading = false
      } catch (error) {
        this.table_loading = false
        this.$toasted.error(error.message)
        this.errors = new Errors(error.errors)
      }
    },
    async save () {
      this.errors = new Errors()
      this.saving = true

      try {
        let response = await this.$store.dispatch(
          'workSchedule/store',
          this.model
        )

        this.$toasted.success(response.message)
      } catch (error) {
        this.$toasted.error(error.message)
        this.errors = new Errors(error.errors)
      }

      this.saving = false
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-container {
  margin-top: 16px;
  background-color: #fff;
  border: solid 1px #d3d8df;
  height: 50vh;
  overflow-y: scroll;
  overflow-x: scroll;
}
.schedule-table-container {
  height: 48vh;
  width: 100px;

  .table > thead > tr > th {
    position: sticky;
    top: 0;
    background: rgba(230, 230, 230, 1);
    z-index: 10;
  }
  table th,
  td {
    padding: 2px 4px;
    vertical-align: middle !important;
    white-space: nowrap;
  }
  .border-none {
    border: none;
    background: #fff;
    width: 45px;
    font-size: 11px;
    outline: none;
  }
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
div::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}
select {
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
  text-align-last: center;
}

option {
  text-align: left;
}
</style>
